import { z } from 'zod';

/**
 * Organization roles.
 */
export const OrgRoleSchema = z.enum(['owner', 'attorney', 'staff', 'read_only']);
export type OrgRole = z.infer<typeof OrgRoleSchema>;

/**
 * Roles that can be assigned via invitation.
 * 'owner' is excluded — ownership is transferred explicitly, not via invite.
 */
export const InvitableOrgRoleSchema = z.enum(['attorney', 'staff', 'read_only']);
export type InvitableOrgRole = z.infer<typeof InvitableOrgRoleSchema>;

/**
 * Display labels for each role, suitable for UI rendering.
 */
export const ROLE_DISPLAY_LABELS = {
  owner: 'Owner',
  attorney: 'Attorney',
  staff: 'Staff',
  read_only: 'Read Only',
} as const;

/**
 * Role hierarchy from most to least privileged.
 * Used for display ordering and comparison.
 */
export const ROLE_HIERARCHY: readonly OrgRole[] = ['owner', 'attorney', 'staff', 'read_only'];
